import { Component, Input, OnInit } from "@angular/core";
import { LicenseInfoService } from "src/app/services/license-info/license-info.service";
import { PreferenceKey, UserPreferenceService } from "src/app/services/user-preference/user-preference.service";
import { StandardSetModel, StandardSetSettings } from "../../settings/standard-set-settings.constants";
import { ScopeSequenceStandard } from "src/app/services/graphql/scope-sequence-standards-response";
import { ActivatedRoute } from "@angular/router";
import { ScopeSequenceSkill } from "src/app/services/graphql/scope-sequence-skills-response";

@Component({
  selector: 'core-concepts',
  templateUrl: './core-concepts.component.html',
  styleUrls: ['./core-concepts.component.scss']
})
export class CoreConceptsComponent implements OnInit {
  @Input() public selectedStandard!: ScopeSequenceStandard;
  @Input() public skills: ScopeSequenceSkill[] = [];

  public selectedStandardSet: StandardSetModel = StandardSetSettings[0];

  public hasFreckle: boolean = false;
  public hasSavvas: boolean = false;
  public standardSetType: string = '';

  public constructor(
    private userPreferenceService: UserPreferenceService,
    private licenseService: LicenseInfoService,
    private route: ActivatedRoute
  ) { }

  public async ngOnInit(): Promise<void> {
    this.hasFreckle = await this.licenseService.currentClassesHaveFreckle();
    this.hasSavvas = await this.hasSavvasAccess();

    this.standardSetType = this.route.snapshot.paramMap.get('standardSetType') || '';
    this.selectedStandardSet = StandardSetSettings.find(x => x.standardSetType.toLowerCase() === this.standardSetType.toLowerCase())!;
  }

  private async hasSavvasAccess(): Promise<boolean> {
    const isSavvasPreferenceEnabledString = await this.userPreferenceService.getPreferenceValue(PreferenceKey.SavvasEnabled);
    const isSavvasPreferenceEnabled = isSavvasPreferenceEnabledString.toLowerCase() === 'true';

    return isSavvasPreferenceEnabled;
  }

  public getSkillIds(): string[] {
    return this.skills.map(skill => skill.skillId);
  }
}
